import { APP_CONFIG } from "@/data/constants";

/**
 * false = 나이스페이 실결제.
 * - 프로 피드백: 할인가 카드 결제 후 접수
 * - 레슨 결제 페이지: 나이스페이 결제
 */
export const PAYMENT_KAKAO_INQUIRY_ONLY = false;

export const PAYMENT_KAKAO_CHANNEL_HANDLE = "@connect-tone";
export const PAYMENT_KAKAO_CHANNEL_URL = APP_CONFIG.KAKAO_CHANNEL_URL;

export function isPaymentKakaoInquiryOnly(): boolean {
  return PAYMENT_KAKAO_INQUIRY_ONLY;
}

/** true면 프로 피드백을 결제 없이 무료 접수한다. 실결제 시 false. */
export function isExpertFeedbackDirectApplyEnabled(): boolean {
  return PAYMENT_KAKAO_INQUIRY_ONLY;
}

export function getPaymentKakaoInquiryMessage(): string {
  return `현재 PG(카드결제) 연동 준비 중이라 앱에서 바로 결제되지 않습니다. 카카오톡 채널 ${PAYMENT_KAKAO_CHANNEL_HANDLE} 로 문의해 주세요.`;
}

export function getExpertFeedbackDirectApplyMessage(): string {
  return "테스트 기간 무료 신청입니다. 신청하면 바로 접수됩니다.";
}

export function openPaymentKakaoInquiry(): void {
  if (typeof window !== "undefined") {
    window.open(PAYMENT_KAKAO_CHANNEL_URL, "_blank", "noopener,noreferrer");
  }
}
